import React from 'react'

import './HeaderNew.scss'
import { arrFooter } from 'commons/constant'
import images from 'assets/images'
import useResizeWidth from 'controller/useResizeWidth'
import { useLocation } from 'react-router-dom'

const menuLeft = [
  {
    title: 'Network',
    link: '/network',
    isBlank: false,
    menus: [
      {
        menuName: '',
        itemMenu: [
          {
            name: 'Masternodes',
            link: '/masternode',
          },
          {
            name: 'Block Explorer',
            link: 'https://www.vicscan.xyz/',
            isBlank: true,
          },
        ],
      },
    ],
  },
  {
    isDeveloper: true,
    title: 'Developers',
    link: '/',
    isBlank: false,
    menus: [
      {
        menuName: '',
        itemMenu: [
          {
            name: 'Documentations',
            link: 'https://docs.viction.xyz/',
            isBlank: true,
          },
          {
            name: 'Developer Hub',
            link: '/developer-hub',
          },
          {
            name: 'Hackathon',
            link: 'http://horizon.viction.xyz/',
            isBlank: true,
          },
          {
            name: 'Game Awards',
            link: 'https://gameawards.viction.xyz/',
            isBlank: true,
          },
        ],
      },
    ],
  },
  {
    title: 'Ecosystem',
    link: '/',
    isBlank: false,
    menus: [
      {
        menuName: '',
        itemMenu: [
          {
            name: 'Ecosystem Landscape',
            link: '/ecosystem',
          },
          {
            name: 'Submit your Project',
            link: 'https://docs.google.com/forms/d/e/1FAIpQLSczKVJWYtigzCmaJeRIyoO-AqLFUmFxXa4ZuO2d9TPHW_zwbA/viewform?usp=sharing',
            isBlank: true,
          },
        ],
      },
    ],
  },
]

const menuRight = [
  {
    name: 'Community Hub',
    link: '/community-hub',
  },
  {
    name: 'Events',
    link: '/event',
  },
  {
    name: 'Ambassador',
    link: 'https://frontierdao.org/',
    isBlank: true,
  },
  {
    name: 'Governance',
    link: 'https://gov.viction.xyz/',
    isBlank: true,
  },
  {
    name: 'Blog',
    link: 'https://blog.viction.xyz/private/?r=%2F',
    isBlank: true,
  },
]

const menuStarted = [
  {
    menuData: [
      {
        name: 'VIC Bridge',
        link: '/bridge',
        icon: images.headerIcon1,
        isComing: false,
      },
      {
        name: 'VIC Gateways',
        link: '/gateway',
        icon: images.headerIcon2,
        isComing: false,
      },
      {
        name: 'VIC Retrodrop',
        link: 'https://retrodrop.viction.xyz/',
        icon: images.headerIcon3,
        isComing: false,
        isBlank: true,
      },
      {
        name: 'VIC Utility',
        link: '/utility',
        icon: images.headerIcon4,
        // isComing: true,
        // isBlank: true,
      },
    ],
  },
  {
    isStarted: true,
    menuData: [
      {
        name: 'Get Started',
        description: 'The details step-by-step of how to start with Viction',
        icon: images.headerIconToken,
        link: '/get-started',
      },
    ],
  },
]

const menuLeftWwc = [
  {
    title: 'Our Vision',
    link: '/our-vision',
    isBlank: false,
    menus: [
      {
        name: 'Vision',
        link: '/world-wide-chain',
      },
    ],
  },
  {
    title: 'Products and Solutions',
    link: '/',
    isBlank: false,
    menus: [
      {
        name: 'Data Availability',
        link: '/viction-da',
      },
      {
        name: 'Chain Development Kit',
        link: '/gaming',
        isHide: true,
      },
      {
        name: 'Game | Social | DeFi | NFT | Payment',
        link: '/defi',
        isHide: true,
      },
    ],
  },
]

const menuRightWwc = [
  {
    title: 'Developers',
    link: '/',
    isBlank: false,
    menus: [
      {
        name: 'Documentations',
        link: 'https://docs.viction.xyz/',
        isBlank: true,
      },
      {
        name: 'Community',
        link: 'https://docs.viction.xyz/',
        isBlank: true,
      },
      {
        name: 'FAQ',
        link: 'https://docs.viction.xyz/',
        isBlank: true,
      },
    ],
  },
  {
    title: 'Ecosystem',
    link: '/',
    isBlank: false,
    menus: [
      {
        name: 'Ecosystem Landscape',
        link: '/ecosystem',
      },
    ],
  },
]

function HeaderNew() {
  const { pathname } = useLocation()

  const { isScrollDown, positionY } = useResizeWidth()

  const backgroundTransparent =
    pathname === '/ecosystem' ||
    pathname === '/masternode' ||
    pathname === '/get-started'
  const isChangeColorText = pathname === '/masternode'

  const [showMenu, setShowMenu] = React.useState(false)

  const onShowMenu = () => {
    setShowMenu(!showMenu)
  }

  return (
    <div
      className={`header-new ${isScrollDown && 'header-new--hide'} ${
        backgroundTransparent && positionY <= 300 && 'header-new--transparent'
      } ${
        isChangeColorText && positionY <= 300 && 'header-new--change-color'
      }`}>
      <div className='header-new-container'>
        <div className='logo'>
          <a href='/'>
            <span className='icon-web_logo'></span>
          </a>

          <span
            className={`icon-${showMenu ? 'ic-cancel' : 'ic-menu'} menu-icon`}
            onClick={onShowMenu}></span>
        </div>

        <div
          className={`header-new-content ${
            showMenu && 'header-new-content--show-menu'
          }`}>
          <div className='menu menu--left'>
            {menuLeft.map((item, index) => {
              const isDeveloper = item.isDeveloper

              return (
                <div className='item-menu text-hover-black'>
                  <div className='menu-title'>{item.title}</div>
                  <div className='menu-child'>
                    <div className='menu-child-content'>
                      {item.menus.map((child, childIndex) => {
                        return (
                          <div className='item-child-wrapper'>
                            {child.menuName && (
                              <div
                                className={`item-child-title item-child-title--${
                                  !isDeveloper && 'hide'
                                }`}>
                                {child.menuName}
                              </div>
                            )}

                            <div
                              className={`item-child-list item-child-list--${
                                !isDeveloper && 'flex'
                              }`}>
                              {child.itemMenu.map((menu, menuIndex) => {
                                return (
                                  <a
                                    href={menu.link}
                                    target={menu.isBlank ? '_blank' : '_self'}
                                    rel='noreferrer'>
                                    <div className='item-child'>
                                      {menu.name}
                                      <span className='icon-web_arrow_up_right arrow-up-right'></span>
                                    </div>
                                  </a>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

          <div className='menu menu--right'>
            <div className='item-menu text-hover-black'>
              <div className='menu-title'>Community</div>
              <div className='menu-child'>
                <div className='menu-child-content'>
                  <div className='item-child-wrapper item-child-wrapper--community'>
                    {menuRight.map((item, index) => {
                      return (
                        <a
                          href={item.link}
                          target={item.isBlank ? '_blank' : '_self'}
                          rel='noreferrer'
                          key={index}>
                          <div className='item-child'>{item.name}</div>
                        </a>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className='item-menu text-hover-black'>
              <div className='menu-title'>Get Started</div>

              <div className='menu-child'>
                <div className='menu-child-content menu-child-content--started'>
                  {menuStarted.map((item, i) => {
                    return (
                      <div
                        className={`item-child-wrapper item-child-wrapper--${
                          item.isStarted && 'started-wrapper'
                        }`}>
                        {item.menuData.map((itemChild, index) => {
                          return !itemChild.isComing ? (
                            <a
                              href={itemChild.link}
                              className={itemChild.isComing && 'link-disable'}
                              key={index}
                              target={itemChild.isBlank ? '_blank' : '_self'}
                              rel='noreferrer nofollower'>
                              <div
                                className={`item-child item-child--get-started ${
                                  item.isStarted && 'item-child--started'
                                }`}>
                                <div
                                  className={`item-child-icon item-child-icon--${
                                    item.isStarted && 'started-icon'
                                  }`}>
                                  <img
                                    src={itemChild.icon}
                                    alt=''
                                    className='img-icon'
                                  />
                                </div>

                                <div className='item-child-text'>
                                  <div className='item-child-title'>
                                    {itemChild.name}
                                    <span className='icon-web_arrow_up_right arrow-up-right'></span>
                                  </div>

                                  {itemChild.description && (
                                    <div className='item-child-description'>
                                      {itemChild.description}
                                    </div>
                                  )}

                                  {itemChild.isComing && (
                                    <div className='item-child-coming'>
                                      Coming soon
                                    </div>
                                  )}
                                </div>
                              </div>
                            </a>
                          ) : (
                            <div
                              className={`item-child item-child--get-started ${
                                item.isStarted && 'item-child--started'
                              }`}
                              key={index}>
                              <div
                                className={`item-child-icon item-child-icon--${
                                  item.isStarted && 'started-icon'
                                }`}>
                                <img
                                  src={itemChild.icon}
                                  alt=''
                                  className='img-icon'
                                />
                              </div>

                              <div className='item-child-text'>
                                <div className='item-child-title'>
                                  {itemChild.name}
                                  <span className='icon-web_arrow_up_right arrow-up-right'></span>
                                </div>

                                {itemChild.description && (
                                  <div className='item-child-description'>
                                    {itemChild.description}
                                  </div>
                                )}

                                {itemChild.isComing && (
                                  <div className='item-child-coming'>
                                    Coming soon
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}
                  {/* <div className='item-child-wrapper'>
                  <div className='item-child'>123</div>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderNew
